import PicShareModal from "./PicShareModal/PicShareModal";
import { PicGeneratorPlugin, ImgLoad } from '@tencent/vft-image-plugins';
import Vue from 'vue';
import vftMonitor from '@tencent/vft-monitor';
var monitor = vftMonitor.getMonitor('d2d-naruto');
PicGeneratorPlugin.install(Vue);
export default {
  name: 'PicShare',
  data: function data() {
    return {
      base64: ''
    };
  },
  components: {
    PicShareModal: PicShareModal,
    ImgLoad: ImgLoad
  },
  methods: {
    onImgLoad: function onImgLoad() {
      this.generateImg();
      monitor.debug({
        modId: 'picShare',
        // 必填,上报的模块英文名
        code: '0',
        // 选填，错误码
        operate: 'download' // 选填，错误的操作类型

      });
    },
    onImgError: function onImgError(e) {
      console.error(e);
      this.alert('图片生成失败，请重试！(image download failed)');
      this.$emit('error', e);
      monitor.debug({
        modId: 'picShare',
        // 必填,上报的模块英文名
        code: '-1',
        // 选填，错误码
        operate: 'download' // 选填，错误的操作类型

      });
    },
    onGenerateSuccess: function onGenerateSuccess(base64) {
      this.$emit('generateSuccess');
      this.base64 = base64;
      monitor.debug({
        modId: 'picShare',
        // 必填,上报的模块英文名
        code: '0',
        // 选填，错误码
        operate: 'generate' // 选填，错误的操作类型

      });
    },
    onGenerateFail: function onGenerateFail(e) {
      console.error(e);
      this.alert('图片生成失败，请重试！(image generate failed)');
      this.$emit('error', e);
      monitor.debug({
        modId: 'picShare',
        // 必填,上报的模块英文名
        code: '-1',
        // 选填，错误码
        operate: 'generate' // 选填，错误的操作类型

      });
    },
    onHide: function onHide() {
      this.$emit('hide');
    },
    onLocalShare: function onLocalShare() {
      this.$emit('share');
    },
    generateImg: function generateImg() {
      this.$refs.generator.generate({
        autoReplace: true,
        scrollX: 0,
        scrollY: 0
      });
    }
  }
};